define((require) => {
    "use strict";

    var _                             = require("underscore"),
        AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        template                      = require("ui/experience/widgets/youtubeWidget/YouTubeWidgetPropertiesView.tpl"),
        YouTubeAccountView            = require("ui/experience/widgets/youtubeWidget/YouTubeAccountView"),
        YouTubeSettingsPropertiesView = require("ui/assets/youtube/settings/YouTubeSettingsPropertiesView"),
        YouTubeService                = require("ui/experience/widgets/youtubeWidget/YouTubeService"),
        YouTubeUtil                   = require("ui/experience/widgets/youtubeWidget/YouTubeUtil"),
        AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    var EXPAND_PROPERTY = "youTubeExpanded";

    /**
     * The properties view for an Youtube widget.
     *
     * @class YoutubeWidgetPropertiesView
     *
     * @cfg {YoutubeWidgetModel} model The model for the Youtube widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("YouTubeWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        ui: {
            searchInput: ".search",
            youtubeResults: ".youtube-results",
            youtubePropertiesAccordion: ".youtube-properties-accordion",
            legend: "legend"
        },

        regions: {
            youtubeResults: ".youtube-results",
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties",
            accountViewRegion: ".account-view-region",
            youtubeSettingsProperties: ".youtube-settings-properties"
        },

        events: {
            "keyup .search": "_searchInputChangeHandler",
            "select .youtube-image": function(event, model) {
                this.model.set("videoID", model.get("videoID"));
            }
        },

        _clearSearch: function() {
            this.ui.searchInput.val("");
            this.youtubeResults.close();
            this.ui.youtubeResults.hide();
        },

        _search: function(query) {
            YouTubeService.search(query)
                .done((response) => {
                    // Theres a chance the view might have been closed during search
                    if (this.isClosed) {
                        return;
                    }

                    var collectionView = YouTubeUtil.toCollectionView(response.items);
                    this.youtubeResults.show(collectionView);
                    this.ui.youtubeResults.show();
                });
        },

        initialize: function() {
            this.__super();

            // Debounce 'search'
            this._search = _.debounce(this._search, 300);
        },

        _searchMostPopularVideos: function() {
            this._search("");
        },

        _searchInputChangeHandler: function() {
            var query = this.ui.searchInput.val();
            this._search(query);
        },

        onRender: function() {
            this.__super();
            if (this.model.has("videoID")) {
                this._clearSearch();
            } else {
                // Add dummy placeholder
                this.ui.searchInput.val("Most popular");
                // Start initial search (the empty string will return the most popular videos)
                this._searchMostPopularVideos();
            }

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.youtubeSettingsProperties.show(new YouTubeSettingsPropertiesView({model: this.model, hideRotation: true}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.accountViewRegion.show(new YouTubeAccountView({widgetModel: this.model}));
        },

        _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.has("videoID");
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeWidgetPropertiesView.js